var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 6.78354H13.5V4.75497C13.5 4.4389 13.2446 4.18354 12.9286 4.18354H7.30357L5.20893 2.17997C5.18228 2.15502 5.14722 2.141 5.11071 2.14069H0.571429C0.255357 2.14069 0 2.39604 0 2.71211V13.2835C0 13.5996 0.255357 13.855 0.571429 13.855H13.0357C13.2679 13.855 13.4786 13.7139 13.5661 13.4978L15.9589 7.56926C15.9857 7.5014 16 7.42819 16 7.35497C16 7.0389 15.7446 6.78354 15.4286 6.78354ZM1.28571 3.4264H4.65179L6.7875 5.46926H12.2143V6.78354H3.10714C2.875 6.78354 2.66429 6.92461 2.57679 7.14069L1.28571 10.3407V3.4264ZM12.6304 12.5693H1.69643L3.54107 7.99783H14.4768L12.6304 12.5693Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColog);
export default __webpack_public_path__ + "static/media/colog.15ec1d26bf4a3d1c8fc933b80248a0d5.svg";
export { ForwardRef as ReactComponent };